'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //TODO: Setup A GO deployment to test integration


var _utils = require('./lib/utils.js');

var _cookieDataEnricher = require('./lib/cookieDataEnricher.js');

var _cookieDataEnricher2 = _interopRequireDefault(_cookieDataEnricher);

var _dataSender = require('./lib/dataSender.js');

var _dataSender2 = _interopRequireDefault(_dataSender);

var _featureDetection = require('./lib/featureDetection.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Analytics = function () {
    function Analytics(options, request) {
        _classCallCheck(this, Analytics);

        if (!request && (0, _featureDetection.isServer)()) {
            throw "Request object is required when calling library from the server";
        }

        this._browserInfo = (0, _utils.getBrowserInfo)(request);

        this._dataSender = new _dataSender2.default((0, _featureDetection.isServer)() ? options.apiUrl + "-server" : options.apiUrl);
        if (process.env.NODE_ENV !== 'production') {
            var Validator = require('./lib/validator.js').Validator;
            this._validator = new Validator();
        }
        this._cookieDataEnricher = new _cookieDataEnricher2.default(this._browserInfo.cookies, (0, _utils.getCurrentEnvironment)(this._browserInfo.url));

        this._isDebug = (0, _utils.queryStringToObject)(this._browserInfo.url).debug_koala ? (0, _utils.queryStringToObject)(this._browserInfo.url).debug_koala.toLowerCase() === 'true' : options.isDebug || false;
    }

    //TODO: Chore: This would be better implemented as a promise
    //TODO: Feature: Cast core fields to lower capitals


    _createClass(Analytics, [{
        key: 'track',
        value: function track(data) {
            var _this = this;

            if (this._eventProperties) {
                data = (0, _utils.extend)(data, this._eventProperties);
            }

            if (this._isDebug && this._validator) {
                return this._validator.validate(data).then(function (validationError) {
                    if (validationError) {
                        console.error('Analytics - ' + validationError);
                        data.failed_validation = true;
                        data.failed_validation_message = validationError;
                    }
                    return data;
                }).then(function (data) {
                    return _this._send(data);
                });
            }

            return this._send(data);
        }
    }, {
        key: '_send',
        value: function _send(data) {
            var _this2 = this;

            data = this._cookieDataEnricher.enrich(data);
            data.device_timestamp = new Date().getTime();
            data.capture_library_version = '1.1.22';
            data.capture_library_type = (0, _featureDetection.isServer)() ? "koala_server" : "koala_client";
            (0, _utils.setValueOrEmptyString)("url", this._browserInfo.url, data);
            (0, _utils.setValueOrEmptyString)("referrer", this._browserInfo.referer, data);
            (0, _utils.setValueOrEmptyString)("user_agent", this._browserInfo.user_agent, data);

            return this._dataSender.sendData(data).then(function (data) {
                if (_this2._isDebug == true) {
                    console.info('DEBUG: Analytics - Data sent ' + data);
                };
                return data;
            });
        }
    }, {
        key: 'set',
        value: function set(eventProperties) {
            this._eventProperties = eventProperties;
        }
    }, {
        key: 'importSchema',
        value: function importSchema(schema) {
            if (this._validator) {
                this._validator.importSchema(schema);
            }
        }

        /* -------------------------------------------- */
        /*              Utility Methods                 */
        /* -------------------------------------------- */

    }, {
        key: 'trackPage',
        value: function trackPage(data) {}
    }, {
        key: 'trackLink',
        value: function trackLink(link, data) {}
    }]);

    return Analytics;
}();

exports.default = Analytics;


// WEBPACK FOOTER //
// ../~/@jg/koala-front-end-analytics/lib/analytics.js